module.exports = __webpack_public_path__ + "img/logoEnergizercolor.57caa232.png";